import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type TagsPayloadCamelPlural } from "interfaces/Tags";

export interface EmbeddedVideosTagsSliceState {
  tags: TagsPayloadCamelPlural;
  error?: Error;
}

const initialState: EmbeddedVideosTagsSliceState = {
  tags: {},
  error: undefined,
};

const embeddedVideosTagsSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.EmbeddedVideos}/tags`,
  initialState,
  reducers: {
    fetchTags(state: EmbeddedVideosTagsSliceState, action: PayloadAction<TagsPayloadCamelPlural>) {
      state.tags = action.payload;
    },
    fetchTagsFailure(state: EmbeddedVideosTagsSliceState, action: PayloadAction<Error>) {
      state.error = action.payload;
    },
    resetTags: (state: EmbeddedVideosTagsSliceState) => {
      state.tags = initialState.tags;
    },
  },
});

export const { fetchTags, fetchTagsFailure, resetTags } = embeddedVideosTagsSlice.actions;

export default embeddedVideosTagsSlice.reducer;
